import { clearEmptyErrors } from '@shared/lib/validation/clearEmptyErrorsValidation/clear-empty-errors';
import { EditFormKeys } from '../config/form-constants';
import { required } from '@shared/lib/validation/validateRequired/required';
import { validateForm } from '@shared/lib/validation/validate/validate';
import { MutateFormFields } from '../ui/modal-mutate-product/types';
import { maxLength } from '@shared/lib/validation/validateMaxLength/max-length';
import { ProductTypesListDataResponse } from '@entities/product/api/product-types';
import { checkProductTypeIsLicense } from '@features/product/mutate-product/lib/check-product-type-is-license';

export const validate = (fields: MutateFormFields, productTypesList?: ProductTypesListDataResponse) => {
    const { validateField, errors } = validateForm();
    console.log('validate fields', fields);

    validateField({
        name: EditFormKeys.Name,
        message: required(fields[EditFormKeys.Name]),
    });

    validateField({
        name: EditFormKeys.Name,
        message: maxLength(fields[EditFormKeys.Name], 177),
    });

    validateField({
        name: EditFormKeys.Description,
        message: required(fields[EditFormKeys.Description]),
    });

    validateField({
        name: EditFormKeys.Code,
        message: required(fields[EditFormKeys.Code]),
    });

    if (!fields[EditFormKeys.WithoutPrice]) {
        validateField({
            name: EditFormKeys.Price,
            message: required(fields[EditFormKeys.Price]),
        });
    }

    validateField({
        name: EditFormKeys.Type,
        message: required(fields[EditFormKeys.Type]?.[0]?.value),
    });

    validateField({
        name: EditFormKeys.TextOrderSuccess,
        message: required(fields[EditFormKeys.TextOrderSuccess]),
    });

    validateField({
        name: EditFormKeys.TextOrderFail,
        message: required(fields[EditFormKeys.TextOrderFail]),
    });

    /* CRM */
    if (checkProductTypeIsLicense(fields[EditFormKeys.Type][0]?.value, productTypesList)) {
        validateField({
            name: EditFormKeys.CRMProductExternalId,
            message: required(fields[EditFormKeys.CRMProductExternalId]?.[0]?.value),
        });
    }

    return clearEmptyErrors(errors);
};
